import { Box, Divider, InputBase, Slider, Toolbar, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Button from 'components/Button/Button';
import { ReactComponent as NotesIcon } from 'assets/images/notes-icon.svg';
import styles from './FooterBar.module.css';

type NotesFooterBarProps = {
  currentPage: number;
  totalPages: number;
  onChangePage: (value: number, fromThumbnail: boolean) => void;
  onChangeZoom: (value: number) => void;
  handleOpenNotes: () => void;
};

const FooterBar = ({
  handleOpenNotes,
  onChangePage,
  onChangeZoom,
  currentPage = 1,
  totalPages,
}: NotesFooterBarProps) => {
  //TODO: logic behind focus page according to the specific page its already implemented, we need to to do it according to the scroll
  const [changePage, setChangePage] = useState<boolean>(false);
  const [zoom, setZoom] = useState<number>(80);
  const minPages = totalPages > 0 ? 1 : 0;

  const handleEdit = () => {
    setChangePage(true);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (Number(e.target.value) === 0) onChangePage(minPages, false);
    setChangePage(false);
  };

  const handleChangePage = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    let value = parseInt(e.target.value, 10);
    if (value > totalPages) value = totalPages;
    if (value < minPages) value = minPages;
    if (Number.isNaN(value)) value = 0;
    onChangePage(value, false);
  };

  const handleChangeZoom = (_: Event, val: number | number[]) => {
    if (typeof val === 'number') {
      setZoom(val);
      onChangeZoom(val);
    }
  };

  useEffect(() => {
    const documentWindow = document.getElementById('document-window');
    if (documentWindow) {
      documentWindow.style.transform = 'scale(' + zoom / 100 + ')';
      documentWindow.style.transformOrigin = '50% 0';
    }
  }, [zoom]);

  return (
    <Box className={styles.footerbar}>
      <Toolbar className={styles.toolbar}>
        <Button aria-label='open drawer' variant='tertiary' startIcon={<NotesIcon />} onClick={handleOpenNotes}>
          Notes
        </Button>

        <Box className={styles.rightTools}>
          {!changePage ? (
            <Button sx={{ minWidth: 'fit-content' }} variant='tertiary' onClick={handleEdit}>
              <Tooltip title='Go To Page' arrow>
                <span>
                  Page {currentPage}/{totalPages}
                </span>
              </Tooltip>
            </Button>
          ) : (
            <Box className={styles.pageText}>
              <Typography>Go to page</Typography>
              <InputBase
                className={styles.pageInput}
                inputMode='numeric'
                inputProps={{
                  maxLength: 3,
                }}
                sx={{
                  '.MuiInputBase-input': {
                    padding: 0,
                  },
                }}
                value={currentPage === 0 ? '' : currentPage}
                onBlur={handleBlur}
                onChange={handleChangePage}
              />
              <Typography> / {totalPages} </Typography>
            </Box>
          )}
          <Divider orientation='vertical' variant='middle' sx={{ height: '28px' }} textAlign='center' />
          <Slider
            size='small'
            min={10}
            defaultValue={80}
            max={200}
            aria-label='Small'
            sx={{ display: 'block' }}
            valueLabelDisplay='off'
            onChange={handleChangeZoom}
          />
          <Tooltip title='Zoom' arrow>
            <Typography className={styles.zoomFormat}>{zoom}%</Typography>
          </Tooltip>
        </Box>
      </Toolbar>
    </Box>
  );
};

export default FooterBar;
